import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Ana', 'Juan', 'Sofía', 'Diego', 'Valentina', 'Mateo', 'Lucía', 'Santiago', 'Camila', 'Sebastián', 'Isabella', 'Alejandro', 'Gabriela'];
const CITIES = ['Buenos Aires', 'Madrid', 'México DF', 'Bogotá', 'Santiago', 'Lima', 'Barcelona', 'Caracas', 'Quito', 'Montevideo', 'Valencia', 'Medellín', 'Guadalajara', 'Córdoba', 'Rosario'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 5000);
    const interval = setInterval(() => {
      triggerNotification();
    }, Math.random() * (12000 - 8000) + 8000); // Random between 8-12 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  };
  if (!visible) return null;
  return <div className={`fixed bottom-4 right-4 z-50 max-w-sm w-full bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 transform transition-all duration-500 ease-in-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-4">
      <div className="flex items-start" data-id="element-5">
        <div className="flex-shrink-0" data-id="element-6">
          <CheckCircle className="h-6 w-6 text-green-500" data-id="element-7" />
        </div>
        <div className="ml-3 w-0 flex-1 pt-0.5" data-id="element-8">
          <p className="text-sm font-medium text-gray-900" data-id="element-9">
            ¡Nueva compra verificada!
          </p>
          <p className="mt-1 text-sm text-gray-500" data-id="element-10">
            <span className="font-bold" data-id="element-11">{data.name}</span> de {data.city} acaba
            de comprar este libro digital.
          </p>
          <p className="mt-1 text-xs text-gray-400" data-id="element-12">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}